import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

let _tokenGetter: (() => string | undefined) | null = null

export function setTokenGetter(getter: () => string | undefined): void {
  _tokenGetter = getter
}

export function getApiToken(): string | undefined {
  return _tokenGetter?.()
}

const _rawBaseQuery = fetchBaseQuery({
  baseUrl: '',
  prepareHeaders: (headers) => {
    const token = _tokenGetter?.()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

export const api = createApi({
  reducerPath: 'engineApi',
  baseQuery: _rawBaseQuery,
  endpoints: () => ({}),
})
